
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Limpo`,
'deleteKey': `⌦ Apagar`,
'downKey': `↓ Para baixo`,
'endKey': `⤓ Fim`,
'enterKey': `Entrar`,
'escapeKey': `⎋ Fuga`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Gerar uma 
          <code>LICENSE
          </code> ficheiro
        `,
'homeKey': `⤒ Início`,
'keyCommand': `⌘ Comando/Win`,
'keyControl': `^ Controlo`,
'keyOption': `⌥ Opção/Alt`,
'keyShift': `⇧ Turno`,
'leftKey': `← Esquerda`,
'pagedownKey': `Pagedown`,
'pageupKey': `▲ Paginar`,
'rightKey': `→ Direito`,
's00065e45db8c0441': `Ver ferramentas de programador para mais pormenores`,
's001dd78415a91fa0': `Calha da barra de deslocação`,
's002fa7d1054ed082': `Caixa de fronteira`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `cazaque`,
's01b56d233c6c5cac': `Seccionamento`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Novo pino...`,
's02ab1ea8e5100fc1': `Marcar a seleção como uma "substituição bidirecional`,
's0312976fe9da5951': `Botão`,
's03608a32f05eded2': `Zoom de pinça`,
's036d35e03be98d22': `Profundidade matemática`,
's037b1dc850a89273': `Alternativa em`,
's0396202b716732ec': `Marcar a seleção como atingida`,
's03f49e598ffb11cc': `Polaco`,
's0448f1059fa01720': `Guarde, partilhe ou imprima o seu explorável. Edite informações como o título, a língua ou a licença.`,
's0458872c43beadef': `Inserir linha antes de`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Espaçamento entre palavras`,
's05e9759cfd99c48f': `Justificar`,
's063fa5a0a4903bf4': `Lado a lado, da esquerda para a direita`,
's064339c229374050': `Codificação`,
's06634274f19b0572': `Seleção de pinos`,
's06743b24499f0035': `Centro de ancoragem`,
's07808b0ca6da8fef': `Sítio Web vedado`,
's07970793b21351fd': `Contentor de base Ruby`,
's079cf7850d9327f0': `Tipo de letra`,
's07aa10850d9ddcc7': `Formulário`,
's07e6118e838b2e23': `Navegação`,
's0816468df86e4036': `Abre as definições`,
's082869038c117fe5': `Português (Brasil)`,
's086e6c267ade2609': `Saturação`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Áudio`,
's0978fb5ba3145996': `Inserir uma lista (não ordenada)`,
's09c3f1d21de14ae1': `Marcar a seleção como sublinhada`,
's0a2d91c6720033e9': `Acabamento do espaçamento do texto`,
's0a3ddcba94027d95': `Ajuste do objeto`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Inserir uma navegação`,
's0a7db790db1fc45c': `Marcar a seleção como um intervalo`,
's0b1271f50a77dc73': `Caixa de conteúdo`,
's0b24d08ea349b455': `Tudo o que se pode inserir. No início estão os elementos não interactivos, como listas ou imagens, e a seguir os elementos interactivos, chamados widgets. Pode obter novos elementos clicando na barra de pesquisa.`,
's0b7ae9543c001867': `Responder`,
's0bdca49248ba4820': `Atalhos`,
's0befccf152b6c0a9': `Orientar a partir de metadados`,
's0c11e479416c8421': `Inserir um título de tabela`,
's0c27336067c59611': `Preenchimento do ecrã`,
's0c4593d81f147042': `Linha de base`,
's0c4b2e98d4ab7f5a': `Comandos da aplicação`,
's0c883713b83616a8': `Guardar o documento ativo`,
's0ca5c0460199cba1': `Abreviatura`,
's0cf10c4f40588f8d': `Legenda do quadro`,
's0d86afa3c6a1e28b': `Direção de flexão`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `O seu documento explorável. Pode escrever texto e copiar/colar, editar, etc. aqui.`,
's0dc07f97c821463c': `Seleção de comentários`,
's0dc452999c129e15': `Ativar o recarregamento em direto`,
's0de0febab8a4beaf': `Erro ao ler este pacote`,
's0e44968489e076a8': `Chinês`,
's0e4862e87c7d53ce': `Marcar a seleção como uma citação`,
's0e6ea8870dbddab2': `Comandos de documentos`,
's0ee28503778e4c0c': `Última linha de base`,
's0ef01c03299bbb83': `Decoração`,
's0f17f32919661cff': `mongol`,
's0f350bc4e538e3ea': `Palavras`,
's105540b7756c0232': `Termo de definição`,
's105a06836c40fcb4': `Definir filtros, cor e mistura de elementos selecionados`,
's106b274b5af798e5': `Frases`,
's1082e1649793dca9': `Marcar a seleção como um termo definido`,
's10f3845975a0351e': `Editar metadados`,
's1125d159f7e64df5': `Ecrã`,
's11326fd2590f4e5e': `Predefinição`,
's1155ec07a221e739': `Barra de deslocamento`,
's1173bf7a3e0b74c9': `Mínimo (y)`,
's1177237a3e0e548c': `Mínimo (x)`,
's1219d97b49650c05': `Visibilidade`,
's123bea44f38abccf': `Inserir objeto`,
's1245e2cb9f20197e': `Alinhar`,
's12946ec1b850962c': `Inserir coluna após`,
's1351209ef74ee729': `Abranger todas as colunas`,
's13c60cb409e8cb6f': `Alinhar ao centro`,
's13ebd619c8a06a6d': `Linhas automáticas da grelha`,
's13ef8ca26ca8861b': `Elemento de corte`,
's151349210ac1d2d8': `Inserir um grupo`,
's151bc2eea7a032a4': `-alterado-`,
's153bc3c3aa39587b': `Cabeça de mesa`,
's156647179b21d351': `Inserir um corpo de tabela`,
's158b6ec6b1fffcb2': `Pausa após`,
's15d0c0657c1ee08c': `Chave API`,
's1626a7e10a9f9dcc': `Define a família de fontes da seleção`,
's1637c7d1a30629e2': `Caixa de fronteira`,
's1641ab440bf4daa4': `Atualizar este pacote de widgets`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avançado: Mostrar pacotes com versões como 0.x.x no gestor de pacotes`,
's16b9446e3a70e1f4': `Atributos`,
's16f205466761e583': `Sem dimensionamento ótico do tipo de letra`,
's16f2f1c2c516d307': `Abrir um documento`,
's1749014f3f87fa6a': `Esticar`,
's17597a8bb4810524': `Licença`,
's17bfaaa4e7528bc7': `bashkir`,
's17fb3f4805f4f4b9': `Remover campo`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Criar pacote`,
's18d5c44aae3dc82a': `Em linha durante a edição`,
's1988d71ef8060edf': `Inserir uma linha de tabela`,
's19abee1277c9bca2': `Samoano`,
's19daf2f26c19543d': `Esboço`,
's1a1acc902e6668e0': `Mostrar formatação avançada de texto`,
's1a5230a71d9285c1': `Captura`,
's1aa1cb63ad44bc6f': `Diferença entre colunas`,
's1af8b67d1c85c811': `Espaço entre`,
's1b4a36fce2456660': `Família de letras`,
's1c246045629b0016': `Marcar a seleção como uma eliminação`,
's1c3fc313a9184670': `Ligação pública`,
's1c65f5004a07dcfa': `Gaélico escocês`,
's1c690963f1e2df00': `Aspeto específico da plataforma`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Quer uma visita curta e guiada?`,
's1d19244f549ec535': `Educação`,
's1d5c7b28e8b50d6d': `Grau de associado.`,
's1db591f5a54dbfd3': `Caixa de conteúdo`,
's1dbb9f50e16c92a3': `Raio da fronteira`,
's1dfb744260fb3a01': `Isolamento bidirecional`,
's1e9c2c654732cc5f': `Bielorrusso`,
's1eaccbf2d6af8ab5': `Informações`,
's1efbfc3937d565bd': `Antecedentes`,
's1f2b49c1bca2035d': `catalão`,
's1f74bdf32b51a5fc': `Imagem de fundo`,
's1f7698c061c208c9': `Aberto`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Córsega`,
's21d61916eb8d137d': `Corpo da mesa`,
's21d723a1dbcd89c8': `javanês`,
's21f8a2eaf5a70749': `Inserir uma etiqueta`,
's2206c42e5b835e6e': `Marcar a seleção como uma abreviatura`,
's22a2348c46a912a0': `Inserir uma secção`,
's233ae776268cd44b': `Negócios`,
's236ed7ba747099b0': `Peso do tipo de letra`,
's2474e7fb1aec9f05': `Teste`,
's2492f5fb1b05b45e': `Texto`,
's24949d7adbb5a098': `Caixa de ferramentas`,
's252a52330d32b900': `Metadados`,
's2540844a4bc4d9ba': `Exigir atribuição?`,
's255857544a9d5ec0': `Reiniciar`,
's255c77900f2b5e0f': `Esquema de cores`,
's256ab831a48c941c': `Remove toda a formatação de texto da seleção`,
's2591806d7b222591': `Redefinir alterações`,
's25e1a07e454c2c11': `Grelha`,
's262abbaf1d05f009': `Luz suave`,
's266935f2447fcd98': `Sobre a esquerda`,
's268ecd1cef45a9a8': `Tens a certeza?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Iluminar`,
's27076e66c5d483ba': `Alinhamento vertical`,
's2712dc5641a33226': `As contas de registo de pacotes destinam-se aos programadores e permitem-lhe configurar um ou mais registos`,
's2739460e44320108': `Chinês (tradicional)`,
's27cc88818cc46ff6': `Estável`,
's281d957112b10f12': `Editar diretamente o HTML do documento`,
's28b6246ce616a548': `Inserir um grupo de colunas de uma tabela`,
's29a1c26521879b9f': `Reduzir a escala`,
's29acfd2778e8c377': `Ocultar formatação avançada de texto`,
's29b24c06315e9343': `Inserir uma entrada`,
's29eb103449472e3b': `Inserir um título (nível 3)`,
's29ee7434494a0dfe': `Inserir um título (nível 2)`,
's29f21c34494d614d': `Inserir um título (nível 1)`,
's29fbfc3449557f72': `Inserir um título (nível 6)`,
's29ff743449588131': `Inserir um título (nível 5)`,
's2a031834495bcdb4': `Inserir um título (nível 4)`,
's2a75c946ef4dcab7': `Diversos`,
's2b2ae20d26f78ac2': `Bloco`,
's2b8f50c64be440f7': str`Selecionar 
          ${0}...
        `,
's2ba5f4d8f3bd7c57': `Encomendar`,
's2bad2d24def4aa0b': `Quebra de linha (CJK lang.)`,
's2ceb11be2290bb1b': `Cancelar`,
's2ced8e8fafb499f6': `Eliminar elemento`,
's2d986d31f8d67357': `Inserir um conjunto de campos`,
's2d995a37cf5e4995': `Inserir um NoScript`,
's2de969afacdaa7a6': `Forma`,
's2df075aface0dab8': `Partilhar`,
's2e192b19ed15fcf6': `Página`,
's2e39b99cf23606fa': `Definir o esquema dos elementos selecionados`,
's2e4818861000b13f': `Disposição`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marati`,
's2eda5288a65bca1d': `Transbordamento (y)`,
's2edd6688a65e21f0': `Transbordamento (x)`,
's2f0bcdffc92a786b': `Flutuar para a direita`,
's2f2044f2431a32d5': `Título`,
's2f4d4bfbc466d91f': `albanês`,
's2f8da2cb5f236588': `O nome do seu pacote. Deve ter escopo, por exemplo, \`@org/pkg\`. `,
's30cce87854901922': `Pré-escolar`,
's3124653c272f054c': `Cor da regra de coluna`,
's314a4f7685c8e824': `Sempre`,
's31c06e226322f065': `Evitar os órfãos`,
's323dcde72b850272': `Acesso público`,
's32911e52ee8ac745': `Inserir uma ranhura`,
's337a1e9022a8d19f': `Tabela`,
's33c1450d2822bb0f': `Inserir uma legenda de figura`,
's33c18d5a4cbffa2a': `Irlandês`,
's33f85f24c0f5f008': `Guardar`,
's342b0cabfa672822': `Ajude o utilizador a encontrar o seu widget`,
's3437e0d9899e7ae1': `Enviar dados de telemetria sobre a sua utilização do WebWriter.`,
's344ea8f4939cdc98': `Cor`,
's34dcda3b0f9d5a98': `Alternar url`,
's34f724979a124c50': `Define a cor de fundo do texto selecionado`,
's355b21b89ce5d9c5': `Detalhes`,
's35ae5f4e0fa2777b': `Alinhamento personalizado`,
's35aeaff1425bca9e': `O WebWriter não suporta suportes do tipo `,
's35c3125c7750681e': `Citação de bloco`,
's3643189d1abbb7f4': `Código`,
's3649bacefe731bf6': `Alternar caixa de ferramentas`,
's365280e16a8ea32d': `Copiar a seleção`,
's366991b9c9287765': `Certo`,
's36a194e38d653a26': `Anotação de dados`,
's36b3cefdcb897f15': `Perspetiva`,
's372fae706048ce41': `Par-ímpar`,
's377e24af9628c37e': `Lista ordenada`,
's37a8c35f6581da5f': `Sem âncora`,
's37fa3b9cd51c2dfd': `Define o tamanho do tipo de letra da seleção`,
's380d17664bb69531': `Inserir coluna antes de`,
's3815184eb09f0dcf': `Cursor`,
's382a2aa3984474dd': `Criar`,
's38980f98cb07ceb8': `Guardar o documento ativo como uma cópia`,
's3914cb410fca44d4': `Importação`,
's3a179f6db2972384': `Posição de rubi`,
's3a5ca02f282d247e': `Partilhar...`,
's3ae67088bbefba98': `Pacotes`,
's3b0ab4b52326316f': `Luz`,
's3bc203a3f8a6409c': `Atualizar a língua em todo o documento`,
's3bdad99768e11911': `Explorável`,
's3cb47df8290fa94c': `Inserir uma opção`,
's3cf89cb47fdde7e9': `Ligação`,
's3d09398e555ee5f9': `Opções avançadas`,
's3d249bb480032121': `Lista`,
's3d3efd1e19bdcfb4': `Anotação de data/hora`,
's3d6a732c792ccb9e': `Anotação Ruby`,
's3d93f9ea0c5a13fa': `Imagem`,
's3d9548e211b958ce': `Saltar sobreposições`,
's3e092e9d1ee2c5bb': `Clipe`,
's3e78ddc9a48a608d': `Bonita`,
's3eb6d1e6e79ed7c4': `Não foram encontrados documentos`,
's3eca5a034978754b': `Eliminar a seleção`,
's3f06e9abb6ebcb79': `Personagens`,
's3f1e7a3f2b283d3b': `Margem`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `gujarati`,
's3f7e097a9b2e6181': `Inserir um artigo`,
's3fd83566dd643d10': `Inserir uma legenda`,
's3fe72792941c18f9': `Fundo do texto`,
's3ffcdc5db5e7d0c5': `Inverter`,
's40e3826b7f74a3b5': `Panela (direita)`,
's40f07d7859284a44': `Linha de base dominante`,
's4101ada154a1b958': `Médio`,
's410c465a5993f82d': `Oportunidade de quebra de linha`,
's41322d19c928c603': `TIC`,
's417b90913e05bc17': `Pré-visualização`,
's418f2020fe996832': `Confirmar alterações`,
's41c724f0698148e9': `Marcar a seleção como um atalho de teclado`,
's41f65a763f8e44ab': `Grupo de cabeçalhos de tabelas`,
's42721130228841b0': `Caixa de curso`,
's429bd646f1cf8bc6': `As contas do Grammar LLM permitem-lhe utilizar a API do Grammar LLM para corrigir a gramática no texto.`,
's429dd933ba95549b': `Inserir um endereço`,
's42e470ef1d707a28': `Jogo automático`,
's42ffdab1291fb3de': `Inserir linha após`,
's430831017f3f0499': `Inclinação (y)`,
's430bd5017f42511c': `Inclinação (x)`,
's433ba70286202ceb': `Quebrar tudo`,
's441b20a8a50e36b4': `Macedónio`,
's445b8acb9206db6e': `Rejeitar e cancelar`,
's446a924922651ea0': `Ênfase no texto`,
's44cdba92713de38e': `Área da grelha`,
's45518abd911471d0': `croata`,
's456a8d744313852a': `Espaço em redor`,
's4634541f5056a546': `Abecásio`,
's46d4abe6255cb9e1': `Reatribuir atalho`,
's4730c232e7209c40': `Aparar ambos`,
's474f0eec369d02a4': `Saída de amostra`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Marcar a seleção como uma anotação de data/hora`,
's47ebf3a8fb3b10c1': `Orientação`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Opção`,
's491d2919cd6ec3d9': `Matiz`,
's497838412cb455f2': `Sombra de texto`,
's4993444bfd3f3e5e': `Colapso`,
's49ad24935b14e3df': `quíchua`,
's49c560aecfeb8c29': `Máscara`,
's49dd67aed00029ef': `Matemática`,
's49e763aed00877a8': `Principal`,
's4a894f57eba1cf1e': `Atalho de teclado`,
's4ac1ad6ecd6bd810': `Ed. diversa.`,
's4ad6e9d3c2365c98': `Luz dura`,
's4b2c143acf931122': `Altura da linha`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Evitar página`,
's4c402ff5355fd310': `Substituição bidirecional`,
's4caed5b7a7e5d89b': `Inglês`,
's4cb38675a21b2c98': `Tipo de propriedade não suportado '\${desc.type}' (processamento como JSON)`,
's4cc8391f172c0cdf': `Desistir da visita`,
's4ce8cc041a628847': `Quando o idioma do documento for alterado, actualize os idiomas de todos os widgets em conformidade.`,
's4d528b416ac8dee2': `Inserir um grupo de títulos`,
's4d546f6c87128d5b': `O espaço em primeiro lugar`,
's4dcb9315f6527f9c': `Executar no recarregamento`,
's4e191bdb4700a6e9': `Sobrecarregar (x)`,
's4e1c7fdb470386ac': `Sobrecarregar (y)`,
's4e2562fe3990e621': `Erro na ligação`,
's4e361bf8eef3759a': `Quebra de palavra`,
's4ea0f21fc2a338a1': `Mover-se para cima`,
's4eace13b3ed74187': `Comentário lateral`,
's4efee5b48a4593cb': `Laço`,
's4f26e7cb7c0a8318': `Desenho Vetorial`,
's4fd2e638aabb0bb3': `O WebWriter suporta a incorporação de muitas fontes diferentes. Basta colar uma hiperligação para o conteúdo de:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Tailandês`,
's5015a8fb33b98872': `Fino`,
's50489ffb1bde152e': `Inserção`,
's5068560b8d39663d': `Mapa clicável`,
's517acbf1f96324f9': `Peso`,
's523eb9043213ff0d': `Itálico`,
's52777d434baeed9b': `Inserir um indicador de progresso`,
's52af5d7ac34c2163': `Linha do quadro`,
's52e0bdc3ee304436': `Inserir um contador`,
's52fb1524cb25d7ab': `Novo tópico`,
's531056f039febd39': `Inserir um seletor`,
's536695196d0b6dc3': `Faeroês`,
's542fcefa0bbaed86': `Abrir ou fechar a caixa de ferramentas (apenas em ecrãs estreitos, caso contrário, a caixa de ferramentas está sempre visível na parte lateral).`,
's5432ad3c84273229': `Figura`,
's543906d1db8b2283': `Editar `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `cambojano`,
's54897f2764b0e4d0': `Instalar este pacote de widgets`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Marcar a seleção como muito importante`,
's55905c735052d295': `Pausa temática`,
's5590dbf7e425789d': `Etiqueta`,
's5623aa2f83b05c76': `tibetano`,
's564d1648b1ceee9f': `Atualizado`,
's565cd5ffb0158c46': `Evitar a região`,
's571a4f19e2f140c7': `Panela (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Voltar atrás`,
's5787c6d5b3b5541a': `Caminho do clip`,
's579c69f419b6caef': `Suave`,
's587ac858dd80f6fa': `Subscrito`,
's58bec0ecd4f3ccd4': `Rigoroso`,
's59404f5593c32fdc': `Espaçamento dos caracteres`,
's5941292bb77281ab': `Norueguês Bokmål`,
's599dcd2472c75c19': `Parágrafo`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Marcar a seleção com uma anotação de dados`,
's5a356677b61a6b7e': `Moldava`,
's5b474b5c0ac0c7c4': `Grupo de colunas do quadro`,
's5b517ac216f9ee62': `De lado`,
's5b8cc9bb61ddce15': `Inserir um parágrafo`,
's5bba2ac2e53bd1fd': `Quirguizistão`,
's5be80ad6b8301710': `Início em linha`,
's5c1ecf88259b79f9': `Apresentação`,
's5c2a1a52c0389c30': `Engenharia`,
's5c63af7695445fcf': `Estilo de texto`,
's5d18ca4c3111be6f': `Inserir um cabeçalho de tabela`,
's5d87c1e588f48d90': `Prática`,
's5d929ff1619ac0c9': `Pesquisar`,
's5da52af9b083c29a': `Modelo`,
's5dc77784260a7236': `automóvel`,
's5e27738a2e8eb763': `Iniciar sessão`,
's5e2cba97c0d971bd': `Recarregar pacotes`,
's5e53415a6d5719ad': `Ciências sociais`,
's5e6a7a0c30d2a270': `Saltar sobreposições (automático)`,
's5e9e8e4d21bafedc': `Produção alimentar`,
's5ed03bb1f3a15949': `Imagem`,
's5f43af3669b1e098': `Fonte`,
's5feaf7fd7ee567c8': `Quebrar a palavra`,
's600fd23c9ce971e8': `Imprimir o documento ativo`,
's602bbd28dae2c60f': `Arranque automático`,
's60ff598dfcf2c773': `Sob direito`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Coluna do quadro`,
's6196153c4b0c1ea0': `Instalar`,
's61c017f6d5c303af': `frísio`,
's61ded17ca3f48c82': `Desvio de sublinhado`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Seleção de cópias`,
's624e31cd4f1b89d4': `Deslocação suave`,
's626daf42b1ab7df7': `Alinhar à esquerda`,
's6280bf993915c57a': `Margem de deslocação`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Descrição`,
's63dfc5b1c1c27849': `Iídiche`,
's63e03c70f67ebf9c': `Contexto`,
's63e71d20d1eaca93': `alemão`,
's640bc7710d0143ce': `Refazer a última alteração não efectuada no documento ativo`,
's64dc1fc7e3db45c9': `Criar um novo documento`,
's65ac276544ba33cd': `Ficheiro SVG`,
's66765c420ee578e4': `Espaço uniforme`,
's669b18c6d2d9c95b': `Nenhum`,
's6747dbf4ad6063ba': `Fim próprio`,
's6787497df07fa97e': `Pode deslocar-se sobre paragens`,
's67c2b60a506a09e4': `Edição secundária.`,
's680bd4d926cd5a84': `Preservar 3D`,
's6827930ef1aeaf99': `URL de base`,
's684a16f3c711394d': `Sobre a direita`,
's687e27f036a71b32': `Isolar`,
's68b87d7b61052dc3': `Linha do quadro`,
's68e0e3a2bab7ce3e': `Evitar`,
's690da6b432987c6f': `Faz automaticamente a cópia de segurança das alterações no documento atual. As alterações são restauradas quando o WebWriter é recarregado.`,
's69311c4e25074fb3': `Ensino secundário`,
's697400b541fbc3cd': `Abaixo de`,
's6988ab5d47593a26': `Tem a versão mais recente do WebWriter.`,
's69a49786a8009f43': `Encontrar pacotes...`,
's69b12144dbb6544d': `Laosiano`,
's69d88ef4b2618980': `Capa`,
's69fbbdb8ad2a084a': `Escurecer`,
's6a31eff1ec4f71ad': `Ocultar a face traseira (3D)`,
's6ac62e1c8c66f3bb': `Superscr. compacto`,
's6b585ba37cdb8260': `Herdar`,
's6b61f8abf89586be': `hebraico`,
's6bd7a02fdf93e653': `Alinhar o conteúdo`,
's6cfc66b824ea05ba': `Bordos nítidos`,
's6d02dc19e21eb49c': `Topo`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `vietnamita`,
's6d8b3b8047ed378d': `Modo de mistura`,
's6d8c02aee480af7a': `Menu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Inserir um estilo`,
's6e288a119281f4c2': `Renderização de texto`,
's6e4c20c6debcd5ca': `Justificação personalizada`,
's6f84199e62584905': `Texto pré-formatado`,
's6fb3053e7244d326': `Outros domínios`,
's70178e04a3b691b6': `Abrir definições`,
's7031ca562378bde6': `Precisão geométrica`,
's7060970b5ed20a58': `Interatividade`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `Nuvem WebWriter`,
's71a0549fd71219c9': `Mostrar pacotes instáveis`,
's71dec51005acc1e4': `Fila densa`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Objeto`,
's731678e227a20559': `Este dispositivo`,
's736904f276fbd441': `Ciências naturais`,
's739544d0c858c633': str`Ou deixe 
          ${0} aqui
        `,
's73cb20c838e761e1': `Seleção de corte`,
's7417792bbe720149': `Refazer`,
's741fae02b3dd24f3': `Pixelada`,
's743f778233e42a3f': `Inserir um aparte`,
's744d993d03f29851': `Ecrã`,
's74540c1b595a229c': `Fórmula TeX`,
's748c0074eff45884': `Manipulação`,
's74aa0039a87141e2': `Elipse`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Caixa de enchimento`,
's75109f5307578a61': `Bem-vindo ao WebWriter`,
's75a27f43413e02c5': `francês`,
's75d83fc3f0cfab40': `Cabeçalho`,
's762e5704cc84089d': `Definir outras opções de estilo dos elementos seleccionados`,
's77318393dfdb0775': `Remover linha`,
's77e594ddcc10c774': `Permitir a utilização comercial?`,
's780099588362f80f': `Item de definição`,
's782eac2b3e80323d': `Marcar a seleção como realçada`,
's782f286a79cca35d': `Relativo`,
's78673a3539cb1915': `Em cima à esquerda`,
's78789724e789221c': `Tamanho`,
's789ff24c8f03f1a4': `Espaçamento entre letras`,
's7995733bf97c01cc': `servo-croata`,
's7a99528e7b64635a': `occitano`,
's7aaf0c06e69600f1': `Erro com `,
's7ae49e142487766c': `Acesso comunitário`,
's7af555180b30a947': `Abrir as ferramentas do programador`,
's7b4ba250601b8667': `Inserir um modelo`,
's7b560d8693ed8f42': `Na vertical`,
's7b9994904c4f5b54': `tajique`,
's7bdf0fd5b014d36c': `Forte importância`,
's7beb1e77e82363eb': `Anular a última alteração no documento ativo`,
's7c61118554a0ec36': `Máximo (x)`,
's7c95876637f6a9d7': `Filtro`,
's7cb4e55c59663b1c': `Empresa`,
's7cfe12cd14df9950': `Sair`,
's7d27db3c9639c6dd': `Alternativa`,
's7d8103f6f06f83d6': `Acolchoamento`,
's7d864465dddbb50d': `Permitir redimensionamento`,
's7de0e28d6c309a4e': `Permitir acções tácteis`,
's7dea785045c3cc74': `Premir nova combinação de teclas...`,
's7e0b179d4d1414eb': `Introduzir ligação`,
's7e6570f2f1ae320f': `Sintetizar tipos de letra`,
's7ecb1f29332293e5': `Linha de base do alinhamento`,
's7ed13ccddb1bf3c3': `Sobreposição`,
's7edbe0b213199995': `Bacharelato`,
's7ede1c55e35ce9d6': `Simulação`,
's7f09197a4814079b': `Definir opções de interatividade para elementos selecionados`,
's7f326a142e856656': `Estilo`,
's7fcb35d23be1e643': `Conjunto de campos`,
's80570196a9ce6d11': `Ativar a telemetria`,
's806f84eb0ace116e': `Veja o que selecionou e altere-o. Copiar, cortar, colar, fixar ou efetuar alterações de esquema. Oferece diferentes opções consoante a sua seleção, ou seja, formatação de texto.`,
's80a42b81c52d4d8f': `Cor do cursor`,
's80b71fc6f43c5ce1': `Solto`,
's812cbda653daaeba': `Esta funcionalidade ainda não está implementada`,
's81c3d8809658b951': `Caxemira`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Continuar`,
's8247d32213e35f24': `Introduzir uma`,
's82665b2ffabc9c0a': `Sítio Web`,
's828b1ecea8715884': `Panela (esquerda)`,
's833bd0422a7ef95d': `Tamanho do separador`,
's83420ad7b6a14db5': `Alternar entre ferramentas de desenvolvimento`,
's83c15613b6f6f3c8': `Apenas em linha`,
's83cd32b685ccc9b7': `Controlos`,
's83f26d02dd7aa681': `Visível`,
's840fa49e8989c028': `Posição/forma`,
's844a76d1843ceb3c': `Repor a predefinição`,
's84e4e8ae645b82ac': `Canto superior direito (y)`,
's84e9c7f8785ca60b': `Inserir um formulário`,
's8517ae4da104b004': `Tabela Grupo de colunas`,
's85186a61e0d55bac': `Vídeo`,
's851a7deea5984646': `Licença como Creative Commons OER?`,
's85f9aa6d3ea0e421': `Grupo de rodapé de tabela`,
's864b0e6270e97246': `Marcar a seleção como um comentário lateral`,
's8670e5ad3bf0dcf8': `Guardar como`,
's8688d74dd3716d6e': `Atalhos de teclado para comandos`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Margem de forma`,
's87cefc710b3567fb': `Conter`,
's88676f992b2965db': `Esticar o conteúdo da célula`,
's886897f2fd4edb99': `Oculto`,
's886c5db2a5579873': `Conceito`,
's888c71e8fcb916d3': `Salvamento automático`,
's88a62d29529948fb': `Inserir uma tabela`,
's89950d86c8004d4b': `Não saltar sobreposições`,
's89bca7498f20e041': `Clip de fundo`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pausa antes de`,
's8a4ff2bd9c13498c': `Registo`,
's8a6585c48ea104e9': `Ocultar células vazias`,
's8a9eb438abac7c6a': `Etiquetas`,
's8b0432eecbd8b034': `Atualização`,
's8b7580c35e2aef87': `Canto superior esquerdo (y)`,
's8bc4affa761aa8a2': `Inserir uma imagem`,
's8c7f51cb067644c7': `Lista de dados`,
's8d342ecaa9e75b9b': `Relacionamento`,
's8d797888455f4147': `Espaços de pausa`,
's8d83386457e91813': `Desfazer/refazer as suas alterações ou pré-visualizar na perspetiva do aluno.`,
's8d8643013a7754d1': `Alinhar texto`,
's8df30fe2a50d3479': `Inserir uma oportunidade de quebra de linha`,
's8e715248c3a78446': `Cortar a seleção`,
's8f29e48d6b9a1aa8': `Inserir uma linha de cabeçalho de tabela`,
's8f4be9f086eb530f': `Anular`,
's8f533296a536965e': `Guardar como...`,
's8fad58c831ecf017': `Contentor de texto Ruby`,
's8ffe7abcbed8eb43': `Vertical, da esquerda para a direita`,
's90105521fcc40453': `As contas WebWriter Cloud permitem-lhe armazenar documentos online e partilhá-los com os seus alunos. Adicione uma conta aqui e esta ficará disponível como local para guardar, carregar, partilhar e abrir documentos.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Paleta de tipos de letra`,
's90f7c1cf501ea0a7': `Cor dodge`,
's91093e0b087911ba': `Posição de destaque`,
's919e1724f589c9b1': `Ranhura`,
's91c5ed7769d00b65': `Inserir incorporação`,
's9219acd5bef6269e': `Em baixo à esquerda`,
's92548405912d46bf': `Alinhamento da deslocação (y)`,
's9258280591309342': `Alinhamento de deslocação (x)`,
's927d796559f49439': `Origem dos antecedentes`,
's92b177e579ef7b97': `Ênfase`,
's92f846b9be2e8e8d': `Marcar a seleção como itálico`,
's93566b84230af4f5': `Inserir uma imagem`,
's936aa0b239679585': `Inserir uma quebra temática (normalmente apresentada como uma linha horizontal)`,
's9370dc6afa716b57': `Fronteira`,
's93f083e654a45715': `Bretão`,
's94653c76b2d86a04': `Prazo definido`,
's9485af2e7cd9418f': `Escola primária`,
's94d2eee44b292567': `Alternar entre opções avançadas`,
's94d61907ee22a8c1': `coreano`,
's94eb1effbbb6498b': `Transbordamento`,
's951aa3a6439f1271': `Marcador de lista`,
's9565553d163fc92a': `Script`,
's957787fc6b7ea5c0': `Panela (para cima)`,
's95d56e58f816d211': `holandês`,
's95d8e41a64635c7c': `Espaço em branco`,
's95de7e1eff6c053e': `Horizontal, de cima para baixo`,
's960d3a90ac199368': `Reto-romeno`,
's96532132a29dd542': `Inserir áudio`,
's96a045dcade75ad0': `Coluna densa`,
's9781a5bb3fcb26a3': `Selecionar primeiro uma empresa`,
's978522fbc9577a7e': `Somali`,
's97881699a2b21d5b': `Lacuna de linha`,
's97aa76056a81bd36': `Métricas`,
's986facb3ecc9602c': `Lado a lado, da direita para a esquerda`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Ficheiro externo`,
's98977a87d1b93941': `Redefinir informações, estilos e scripts`,
's98b1cb8fb62909ec': `Grupo`,
's990d0e0fa2ab00b5': `galego`,
's99229574e5692f19': `Gronelandês`,
's99a990f3841ad283': `Ficheiros de `,
's99b38e000175cc84': `Riscado`,
's99f110d27e30b289': `Título`,
's9ab10fbf4c7a7322': `Posição do sublinhado`,
's9abadcc828884d7b': `Área de texto`,
's9b7cd8860c8fc922': str`
          ${0} será substituído. Tem a certeza?
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Cor de fundo`,
's9ca757effd747da9': `urdu`,
's9caf10388ab3562f': `Coluna do quadro`,
's9cf68f87b8e6122f': `azerbaijanês`,
's9d167ef77aed79b6': `Camada`,
's9d2d00982edafabb': `Turco`,
's9d430adc5be110e9': `Linha inversa`,
's9d54829be67943d3': `Interligação`,
's9d54869be6794a9f': `Interlíngua`,
's9d668a34af4128ff': `Eliminação`,
's9df571714a1efb44': `Está disponível uma versão guardada automaticamente deste explorável. Carregá-la?`,
's9e28faa598332e2b': `Inserir vídeo`,
's9e3dbb678150edd4': `Definir família de fontes`,
's9e40e59654c8ad67': `Coluna`,
's9e85800d3700e31c': `Pista`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Variante de letra`,
's9f1ecdb3061d9cbc': `Preservar os espaços`,
's9faf26107ed49fb9': `Inserir uma célula de tabela`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Transição`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Tela`,
'sa00df4e39c72d3b4': str`
          ${0} não é suportado
        `,
'sa013e119fec906fb': `Fila`,
'sa01e7bf33563ef72': `Anexo de fundo`,
'sa126cf8c627cec1e': `Renderização de imagens`,
'sa13f72278add7513': `Sob direito`,
'sa1647e3b36ec08d7': `Combinar na vertical`,
'sa172190ea21f9b1c': `Aceder às definições, abrir um explorável ou criar um novo.`,
'sa1c6c459b9b5115c': `Absoluto`,
'sa2cba871f6cdd99f': `assamês`,
'sa2eff4dad1c119f1': `Modelo de grelha`,
'sa30c12014e955946': `Russo`,
'sa30f1981fd1cd441': `Tamanho da letra`,
'sa311a24c1471a974': `Documento`,
'sa352d168b262aa06': `Inserir um rodapé`,
'sa37fee6a52d18063': `Eliminar documento`,
'sa39c7ac1d37f3bce': `Marcar a seleção como um "isolado bidirecional`,
'sa3b4c01623211544': `Força`,
'sa40fd43756fa8913': `Persa`,
'sa417644bef21a9aa': `Tema sem nome`,
'sa43800e28be1bdbc': `Cor da decoração`,
'sa477cb1825dceb3b': `sudanês`,
'sa492a51a707930fa': `Inserir uma citação em bloco`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Legenda em baixo`,
'sa50d3c35533f1d99': `Todos os domínios`,
'sa53c5cb03a8fda50': `Fixar a seleção como um excerto na paleta`,
'sa557ae6bee9148a6': `Progresso`,
'sa589e1df65dde0ec': `Definir o tamanho, o preenchimento e as margens dos elementos selecionados`,
'sa5c371b4bb75e590': `Esquerda`,
'sa5c80e623459ffe4': `Inserir um cabeçalho`,
'sa5df1bcdba46c3fb': `Figura Legenda`,
'sa602e3fd3f2d98fd': `Animação`,
'sa644d580d8a11e60': `Alinhamento do rubi`,
'sa645d315510dc09e': `Selecionar o caminho a partir do disco`,
'sa65d4ad99f1d8c06': `Definir o fundo do texto`,
'sa6607436f60ccc1a': `estónio`,
'sa6f8d27bca557059': `Mover elementos meta/link/style para cima/para baixo neste elemento`,
'sa757645ad842da97': `Conservar as pausas`,
'sa75b95980cd80e78': `Editor`,
'sa7698b3d20a6d1ec': `Pergaminho`,
'sa778acc33947c7b8': `Terminar a digressão`,
'sa78a67272a4a6f95': `Fórmula matemática`,
'sa79167651dce1e80': `Texto alternativo`,
'sa7af797a46c7d09a': `Rodapé da tabela`,
'sa7dbe35b758c138d': `Inserir uma tela`,
'sa7dc6b8ef3f595dc': `Inserir uma fonte`,
'sa8279f8211b3950d': `Preservar pausas e espaços`,
'sa8b55cab62e439b5': `Remover coluna`,
'sa8bbe0197d31b423': `Breve descrição`,
'sa9ff3b762365abe6': `Origem da transformação (z)`,
'saa02e3762368ff35': `Transformar a origem (y)`,
'saa065776236bfa28': `Transformar a origem (x)`,
'saa33768e03c45fc8': `Tamanho do ficheiro`,
'saaad98061a20ac39': `Inserir uma fórmula matemática`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Alternar sobre`,
'saaec15c97a9e4245': `Coluna Inverter`,
'sab0c57df694a0a09': `Início do corte`,
'sab4d9283896d9422': `Píxeis de resolução instantânea`,
'sab55faae8e165407': `Preenchimento&lt;br&gt; como espaço`,
'sab5e7d2a069a2951': `Certificado profissional.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Alinhar à direita`,
'sac895c732f350ac5': `Escuro`,
'saced41ddda8b2354': `Base flexível`,
'sad190f86451081c0': `nepalês`,
'sad6be321164d08c8': `Matemática compacta`,
'sadd352cc7f6f2307': `À parte`,
'sae098810f946ca7c': `Tagalo`,
'sae185e6af80ec81e': `Sueco`,
'sae1c7f13b7c0c47f': `Início`,
'sae76e25497dcee58': `Reto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `tártaro`,
'saf312eaeec77a802': `Inserir uma lista de descrição (glossário, lista de termos)`,
'saf3da7c95cb17260': `Marcar a seleção como um sobrescrito`,
'saf440a0a592f2835': `Atualizar para`,
'saf9e5134ba1a7d30': `Deslocação rápida`,
'safc6f203342d09e2': `Alterna a pré-visualização do documento ativo`,
'sb0a7e3adf4a125ee': `Em cima à direita`,
'sb0a974028c99ca6d': `Permitir adaptações?`,
'sb0d4f0f7993cf085': `Definir o tamanho do tipo de letra`,
'sb0f3327210fe18fc': `Colunas`,
'sb0f93c1c60c0249a': `Base de rubi`,
'sb1494c08c8c720d1': `Definir a cor do texto`,
'sb19611adbc88f711': `Avançado: Mostrar comandos de edição da fonte, por exemplo, para mostrar o HTML do documento ou para adicionar estilos e scripts personalizados.`,
'sb206d700d26b14ff': `Sublinhar`,
'sb233557012dcb328': `Deslocar-se para baixo`,
'sb26035b596566abf': `Sem nome`,
'sb2cda80610c8d6ea': `Espaço todos`,
'sb2dc787b0983ebc6': `lituano`,
'sb31cdff08b1c5a50': `Sindi`,
'sb38d497d992ab4a4': `Centro`,
'sb3ba3276ae93627c': `Inserir um bloco de texto pré-formatado`,
'sb430f5b4824de0d3': `Selecionar um esquema`,
'sb43db07b24da018a': `amárico`,
'sb45f9fb4dba6e71a': `Não definido`,
'sb4e003a459464d85': `curdo`,
'sb4f0310e6787d098': `uzbeque`,
'sb4f1dffbb6be6302': `Limpo`,
'sb51270e19988f9bd': `Região`,
'sb59d621e3c93cc27': `Fronteiras de células partilhadas`,
'sb5e9e1776242b028': `Interações`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doutoramento`,
'sb6103872073d369e': `Inserir pormenores`,
'sb616811735bfbafd': `Célula do quadro`,
'sb628960829e223bb': `Saltar todas as sobreposições`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Aplicar e importar`,
'sb66e2181a7b5738a': `Ao ativar a telemetria, o utilizador permite a recolha e retenção de dados de acordo com a nossa`,
'sb67e0e7c0869f982': `Diferença`,
'sb68e83cda6c85af8': `Cabeçalho do quadro`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Espessura da decoração`,
'sb70c17f7899f9b01': `Latina`,
'sb71941f552f3504d': `Definir valor especial`,
'sb740eab4afd5a710': `Fluxo automático da grelha`,
'sb741b6e0ca589122': `Reverter camada`,
'sb7c77d0415de05cf': `Executar testes`,
'sb7fb7568f6883ab8': `Partilhar o documento ativo`,
'sb85774dc5d18ff0f': `Confirmar`,
'sb85b1e36579852a6': `E-mail ou palavra-passe inválidos`,
'sb884fa76bfc55429': `Árabe`,
'sb8a3d4df7d1c5e6b': `Equilíbrio`,
'sb8f610a0e8df91fc': `Luminosidade`,
'sb8f855b49234b81b': `Aplicar`,
'sb905da066c10182c': `Mais escuro`,
'sb940ade1bd81be7e': `Abaixo da esquerda`,
'sb9e9a7dd45966756': `Marcar a seleção a negrito`,
'sba509fd8ed61d1d5': `Ficheiro não guardado`,
'sba64d8954d027206': `Opacidade`,
'sba88d90cd6c751b3': `Regra de coluna`,
'sbaf0a7c417e388af': `Saúde`,
'sbb15d427ee1aa676': `Tigrínia`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filtro de fundo`,
'sbb85a407d730e13d': `Inserir uma pesquisa`,
'sbb86c6c96f598bb8': `Misto`,
'sbba0156f795d8c07': `Editar seleção`,
'sbba865d4b437944f': `Atributo`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Desinstalar`,
'sbc5f2a81604baf9b': `Rubrica 6`,
'sbc5f2b81604bb14e': `Rubrica 5`,
'sbc5f2c81604bb301': `Rubrica 4`,
'sbc5f2d81604bb4b4': `Rubrica 3`,
'sbc5f2e81604bb667': `Rubrica 2`,
'sbc6953a36ced943f': `política de privacidade`,
'sbd181cd54b8402a4': `Editar a seleção`,
'sbd35ee879d9cf770': `Texto de rubi`,
'sbd40f40cbadd38d5': `Remover este pacote de widgets`,
'sbd72dc858de95ce8': `birmanês`,
'sbe3c60c65f129daa': `Humanidades`,
'sbe4a7c8f231739b3': `ou colar/soltar/escolher ficheiro`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Inserir uma quebra de linha`,
'sbf00e1ee999ea94e': `Inserir um script`,
'sbf519920c2017d67': `Pendurado`,
'sbfa01f189a68d3e9': `Crescimento flexível`,
'sbff54e740c4086eb': `Mostrar pacotes desconhecidos`,
'sbfff51feacf30196': `sânscrito`,
'sc0ceaa9843510f67': `Turquemenistão`,
'sc1611c0558728a2a': `Posição`,
'sc1a155cc25899250': `Grupo de linhas de tabela`,
'sc1aa1f6051b7102a': `romeno`,
'sc1edebeaef92b7bd': `Disposição fixa da tabela`,
'sc1fff4f356dfb2fb': `Transformar`,
'sc221faca1ecb4aee': `Anónimo`,
'sc24bda3c061fddf8': `Área clicável`,
'sc252a4e091763606': `Inserir um rodapé de tabela`,
'sc2536e077514accc': `Deslocação`,
'sc275dd00036d16cb': `Citações de carácter`,
'sc28864200d2a3799': `Copiar o código QR como imagem`,
'sc2a24a9dd41a9503': `Linha de decoração`,
'sc2b734cca2fa643b': `Pan (para baixo)`,
'sc2e2a0dbf03723b7': `Avançado: Mostrar pacotes de fontes desconhecidas no gestor de pacotes (Aviso: Pode não ser seguro)`,
'sc3998b77d72c2932': `Inserir um sítio Web (como uma moldura em linha)`,
'sc3ac225273c8316b': `Geral`,
'sc3cfee84dbbf36ae': `Ficheiro local`,
'sc3f09a9b6fa4fbed': `No interior`,
'sc43767deea72e9f3': `Lista descritiva`,
'sc462bbdd36bcba6b': `Caixa de referência`,
'sc4ee3e4ee994dafd': `ucraniano`,
'sc50d09edf9325339': `Diálogo`,
'sc52b67794c06a0d3': `Origem da perspetiva (y)`,
'sc52e8b794c0913d6': `Origem da perspetiva (x)`,
'sc53de149fcaad713': `Inter-caracteres`,
'sc546f489f9c0cced': `Alterna o modo de teste para o documento ativo`,
'sc5bcf50d1b578d9f': `Definições da caraterística do tipo de letra`,
'sc5cb39478b9b7625': `Marcar a seleção como um subscrito`,
'sc6415b50ff928294': `Item da lista`,
'sc650ff15b20fe9d3': `Rodar (z)`,
'sc6578b15b2154365': `Rodar (x)`,
'sc65aff15b2183e58': `Rodar (y)`,
'sc6da0f4a7e4d710e': `Substituição do idioma do tipo de letra`,
'sc74e3567875ce255': `Tanto a etiqueta do seu widget como o nome do seu pacote NPM`,
'sc7eb080b96e244df': `Malaio`,
'sc8ac7ef92b95df3f': `Mover (x)`,
'sc8af536e2084ade0': `Paleta`,
'sc8b022f92b992bc2': `Mover (y)`,
'sc8b39af92b9c2d81': `Mover (z)`,
'sc8d2c7f6c33a2b32': `Definir o estilo do texto (alinhamento, indentação, espaçamento, etc.) dos elementos seleccionados`,
'sc8fa0e3de389ef1c': `Ajustar o tamanho dos caracteres`,
'sc9474bf7a0668d73': `Resumo`,
'sc94e314312a8900c': `Checo`,
'sc980855a000b76ea': `Fundo`,
'sc98b103772de63f4': `finlandês`,
'sca7cfe2bef51b2a5': `Raiz`,
'sca7fed2bef53cb99': `Papel`,
'scabe6ecee5e01fd2': `maltês`,
'scace301a88231cce': `Incorporar`,
'scbc55f622ec078c1': `Ver caixa`,
'scbe537fc38ff4c13': `Colunas automáticas da grelha`,
'scc1db59d292cbc4c': `Secção`,
'scc56b218a2689c42': `arménio`,
'scc5ba32e0de06744': `sesoto`,
'scd15088c39fe9edf': `Caixa de enchimento`,
'scd9cedeb5ece3adb': `Hifenizar`,
'scdf536b65be39ec5': ` Criar/importar`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideográfico`,
'sceecdd0bb404bc17': `Inserir um grupo de opções`,
'scf00d48fd5953a03': `grego`,
'scf932840a69dbb7c': `Português`,
'scf932a8577057752': `Rodapé`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Em baixo à direita`,
'sd01178c54f648118': `Colunas de balanço`,
'sd03bff50f87f82d4': `Carácter hifenizado`,
'sd05a155fe09c2866': `Online ao utilizar`,
'sd0864ea6cb6ef22e': `Comunidade`,
'sd10fdbe6caf9a998': `Quebra de linha`,
'sd121d3b959b7888d': `Otimizar a velocidade`,
'sd1a78e667a1a139f': `Marcar a seleção como uma inserção`,
'sd1cffad290ea5b3b': `Manter tudo`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `Correio eletrónico`,
'sd1f81984eeb7c0e8': `Preencher`,
'sd29dc07235eea0f5': `Cotação`,
'sd2addf69477cd4b4': `Pacote de importação`,
'sd2ed26defc646d47': `Filtro de fundo`,
'sd2ef82b8ea877c6d': `africâner`,
'sd319aae1401f1e19': `Fixo`,
'sd3a288c1094b8a63': `Largura da regra da coluna`,
'sd3c65ef5c380c046': `Inserção`,
'sd3dcb76f7b28adb8': `letão`,
'sd3eca1e0f4209f6e': `Recortar tudo`,
'sd3f402df8619ddcd': `Estas informações sobre si são adicionadas automaticamente aos novos documentos. Pode alterar isto para cada documento no editor de metadados.`,
'sd4368b12645d3c0f': `Inserir um portal`,
'sd452cebf4a0313d1': `Mostrar comandos de edição da fonte`,
'sd48cc52117f4d68b': `italiano`,
'sd52660ee947ca58b': `Inserir uma coluna de tabela`,
'sd588d17a1b25c220': `Excesso de texto`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Ensino superior.`,
'sd5cf95145e4d89ca': `Desafixar este excerto`,
'sd5fd9d11a92f5b1d': `Fundo à esquerda (y)`,
'sd60c9bbc51375635': `Inserir um botão`,
'sd66c4767fa3dde28': `Cor de destaque`,
'sd679c8b1bf8cc8a5': `Pequenas empresas`,
'sd7086c4425c53c80': `Família de fontes`,
'sd837f42ac7cbfb58': `Forma (exterior)`,
'sd88076d2994ee0fb': `Exclusão`,
'sd89a2e529b31ef43': `Reverter`,
'sd8a345e95668b73b': `Vertical, da direita para a esquerda`,
'sd8ce9e57270b030d': `Extensão do tipo de letra`,
'sd8ecf227c7c49331': `Matemático`,
'sd8f923198e0c5c6a': `Fim`,
'sd9c21e5f60d6bdd8': `Dinamarquesa`,
'sd9ff8e2612e63d50': `Dimensionamento da caixa de fronteira`,
'sda2d76b976502a8d': `Abrir...`,
'sda344aacb837387e': `Posição no contentor`,
'sda5b6fa8b771f996': `Flutuar para a esquerda`,
'sda9254d1f1228e1a': `húngaro`,
'sdb1595f5c742dfbb': `Entrada`,
'sdb711380a28fec75': `Inserir uma lista (ordenada)`,
'sdb73788b3c975f16': `Automóvel`,
'sdbee7e0523a23a42': `Canto inferior direito (y)`,
'sdc12d4d35420eeb7': `Comentários`,
'sdc48456f9a27ae02': `Gerador`,
'sdc70d81cf6c28533': `georgiano`,
'sdd1ff479d04ac140': `Público`,
'sdd2fc8919a9c3111': `Modo de mistura do fundo`,
'sdd35b688281b6dea': `Japonês`,
'sddc49047f66a64ab': `Nenhuma descrição fornecida`,
'sdef34fe08bb28b09': `Chinês (simplificado)`,
'sdf62e305e1594805': `Marcar a seleção com uma anotação rubi`,
'sdf946172dfa0328f': `Sobrescrito`,
'sdf9bc5d9b7f3e3de': `Alinhamento`,
'se036b53f145441cd': `Conteúdo misto`,
'se06f459fccdc3ce9': `Alinhar a última linha de texto`,
'se0a782a8be8e018b': `Norueguês`,
'se0cda6b80a1bb50f': `Eslovaco`,
'se0f67eae944f8f94': `Sem som`,
'se1312d6528f9a259': `iorubá`,
'se16c5e66886fbc59': `Artigo`,
'se1f5bb0386c88f96': `Define a cor do texto selecionado`,
'se219da7b1e955c65': `Formatação clara`,
'se25e4f2cb77b8be8': `Língua para a interface WebWriter e novos documentos`,
'se2796c5824ec8916': `Visibilidade do conteúdo`,
'se308836a594808b6': `cingalês`,
'se36c5b1baf5e0660': `Em qualquer lugar`,
'se39c065efa467782': `basco`,
'se3b4c857f91f80d7': `Atalhos de teclado`,
'se47baf2fd16b9d2b': `Modelo`,
'se48bd9e6c2a3109d': `Contas`,
'se58467472725ad0c': `Resolução da imagem`,
'se58f06c2b0583ff7': `Escolher coordenadas`,
'se5dc1e97fb743ade': `Espaçamento`,
'se619a501d1bfe6a5': `Embrulho`,
'se62385ac082368d2': `Marcar a seleção como uma fonte de citação`,
'se6297163cac9d276': `Editar fonte`,
'se633223a0b88625e': `Colocação de células`,
'se638417c560cfe5c': `Quebrar o interior`,
'se64f418b4e733b6c': `Inserir uma saída`,
'se79c0a3ac70d8fb3': `Rácio Asp. (x)`,
'se79fae3ac710dc36': `Rácio Asp. (y)`,
'se7fad370d8fb4cec': `Otimizar a legibilidade`,
'se8a94b4effa2033e': `Alfabético`,
'se95d4e55ea186d9a': `Cor da barra de deslocação`,
'se96d43a515b8451c': `esloveno`,
'se96fd76ba1b2975a': `Central`,
'se9ac05f36b004eb0': `Ocultar a visita de apresentação. Desativar para que a visita guiada seja novamente apresentada.`,
'se9b1fec72ffd8f48': `Local`,
'sea24bdcaa2bd2dec': `Instantâneo obrigatório`,
'sea52df2b70a5c10d': `Rubi`,
'sea6e7291e27ec53f': `Alterna o editor de metadados`,
'sea896ed51ad33287': `Não existem estilos específicos disponíveis`,
'seaaaeb09e3b4e78b': `Comandos de edição`,
'seabae79729c4b2ad': `Alternar e-mail`,
'seaecc8267bad6234': `Ensino médio`,
'seaf97719986faf4f': `Lacuna`,
'seb19675a580f0628': `Evitar a coluna`,
'seb4e52ef5ec7a7dc': `Cores/Efeitos`,
'seb8982ae8c3cdcc5': `indonésio`,
'sebbced89e0db2894': `Primeira linha de base`,
'sec02109a0dd2a6c8': `Cor de realce`,
'sec2557a35b702525': `Variável`,
'sec2da4aa7a02b925': `islandês`,
'sec30fbb20f102670': `Inserir resumo`,
'sec8b0b6c729816b6': `Grupo de títulos`,
'seccd05955adb76bc': `Cartaz`,
'sed17285cd25d6389': `Diretório onde se encontra package.json`,
'sed318ec045c5144f': `Sobre`,
'sed713f1b916fb469': `Espaçamento das margens (x)`,
'sed74a31b9172942c': `Espaçamento das margens (y)`,
'sed86bd0deb2e5372': `Transformar texto`,
'see2fcaedf9743ec6': `Localização`,
'seec6798afe90ffc8': `Imprimir`,
'sef00c258bc1ecf1e': `Este explorável tem alterações não guardadas.`,
'sef23dd271edd4a8b': `Em baixo à esquerda`,
'sef24caccbd4645ef': `Retração flexível`,
'sef49aec68fd1dc66': `Nome`,
'sef73fe18e351eb35': `Palavras-chave`,
'sef75f458d77491af': `Grupo de opções`,
'sefcf950b3cc4fc3b': `Língua`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Conteúdo`,
'sf0cab2483f66aa2e': `Personalizado`,
'sf0e261e04eda82ff': `Aparência`,
'sf1045382c1fd9a85': `Cores exactas de impressão`,
'sf14c35392ec7bf10': `Esta funcionalidade não está disponível no Firefox. Está disponível no Chrome ou no Edge.`,
'sf14f9d5f9f6ca342': `Mais leve`,
'sf1868dc19e3917bb': `espanhol`,
'sf190149f9d8bbb2a': `Modo de escrita`,
'sf1e79171c4856543': `Tem a certeza? Esta ação não pode ser revertida, todas as suas definições serão eliminadas e repostas.`,
'sf21c1f60c7515f44': `Marcar a seleção como saída de amostra`,
'sf21fb4f4b9e8911f': `Largura`,
'sf22a3737146ec910': `O WebWriter pode incorporar SVG diretamente no documento.`,
'sf2514d5dc78b1654': `Inserir widget`,
'sf28903d4ca0ddcfc': `Remover esta conta`,
'sf2ab37af0abc55ef': `Esconder a visita de introdução`,
'sf2bdb0b4d7b9c039': `bengali`,
'sf2cbb5e519264e67': `Redimensionar na horizontal e na vertical`,
'sf2d5cbc2fe0ad65a': `Pegajoso`,
'sf2d96d0eb32cb81f': `Composição da animação`,
'sf2de3dbe2108637a': `Renderização de formas`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Em linha`,
'sf39736a666dbb038': `Inserir uma faixa`,
'sf3c4da68b08a2590': `malgaxe`,
'sf471ec2496f904cc': `Rejeitar alterações`,
'sf4849bc200e279ed': `Legenda do quadro`,
'sf486ca1fdbe08645': `Inserir uma figura`,
'sf4b537d4cbd8f5fd': `Topo do texto`,
'sf4e0e02a5277ef23': `Inserir uma área de texto`,
'sf4f067d41efd4b83': `Escala (y)`,
'sf4f3cbd41f002b46': `Escala (x)`,
'sf4fa67d41f05a008': `Escala (z)`,
'sf5197db2d5f2926a': `Rodar`,
'sf52d840949a980d1': str`
          ${0} será eliminado permanentemente. Tem a certeza?
        `,
'sf55d634dcc743595': `Serviços`,
'sf59c9081d106dd9c': `Marcar a seleção como uma variável`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Eliminar um documento`,
'sf65df67a03bebe4b': `Necessário para este widget`,
'sf6673729c03ae999': `Reiniciar o WebWriter`,
'sf67571992e7dc88e': `Prazo total`,
'sf6b4934598f7ed10': `Permitir seleção`,
'sf6e1665c7022a1f8': `Palavra-passe`,
'sf79e0d78b56444f1': `Extremidade em linha`,
'sf7a5f7a7c80c3082': `Ambos`,
'sf7c0eba7c822e3d6': `Negrito`,
'sf86bd4d2982f3b74': `Marcar a seleção como código`,
'sf8e82313fa411494': `Marcar a seleção como uma ligação`,
'sf955eff73fb6b573': `sérvio`,
'sf9929e2d356260c5': `Multiplicar`,
'sf993bb199fefbe04': `Todos`,
'sf9ecf969dd4b8164': `Ambos os bordos`,
'sf9f2c719a04066ec': `Aplicação`,
'sfa49a5bb1a5d353e': `Acesso privado`,
'sfa59c7777e2a0eeb': `Inserir uma lista de dados`,
'sfaa0a67db5c11f72': `Indentação da primeira linha de texto`,
'sfb231a52211b133f': `Sem quebra de texto`,
'sfb68cae41d749423': `Inicial`,
'sfb9b6edb0ed378c9': `Fonte de citação`,
'sfbbab09dbe553571': `Inserir um desenho vetorial (SVG)`,
'sfc00292e778b67e2': `Contador`,
'sfc63e31ac7c956ed': `Selecionar`,
'sfc815c9078bba30a': `Descarregar o código QR como imagem`,
'sfcdd8e672c75b713': `Endereço`,
'sfcebd18506f1e535': `Fluxo`,
'sfd0cde85070d2eb2': `Flexível`,
'sfd77270c3f54f664': `Saída`,
'sfdb1e4d90981a535': `Partilhar este documento`,
'sfdeef3dccf409f81': `Esta palavra-chave é necessária para widgets`,
'sfe6e758ad2603c1d': `Mestrado`,
'sfee1c12daf838935': `Queimadura de cor`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Inserir um diálogo`,
'sffa395f64ec6ac36': `búlgaro`,
'sffdadf0a576fd802': `Altura`,
'spaceKey': `Espaço`,
'tabKey': `⭾ Tabulação`,
'upKey': `↑ Para cima`,
    };
  